// extracted by mini-css-extract-plugin
export default {"wrap":"ReplacementsComponent_wrap__JJpVi"};